/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { useAthletesByIds } from '@api/hooks';
import { AthleteSelect, InfoItem, SortableArrayField, AddSelectEntity, ContentModuleModal } from '@molecules';
import { NO_MARGIN_BOTTOM } from '@constants';

import Form from '../Form';

import Item from './Item';
import { FORM_FIELD, FORM_FIELDS, INITIAL_VALUES } from './constants';

const FeaturedAthletesModal = ({
  visible,
  hide,
  previewImg,
  onDelete,
  onSubmit,
  initialValues = INITIAL_VALUES,
  errors,
}) => {
  const [form] = Form.useForm(FORM_FIELDS);
  const athletesQuery = useAthletesByIds(initialValues[FORM_FIELD.ATHLETES.name].map(({ athleteId }) => athleteId));

  React.useEffect(() => {
    if (visible && athletesQuery.status === 'success') {
      form.setFieldsValue({ [FORM_FIELD.ATHLETES.name]: athletesQuery.athletes });
    }
  }, [athletesQuery.athletes, athletesQuery.status, form, visible]);

  const handleClose = () => {
    form.resetFields();
    hide();
  };

  const handleSubmit = (values) => {
    onSubmit(values);
    handleClose();
  };

  const handleAddAthlete = async (newAthlete) => {
    const previousAthletes = form.getFieldValue(FORM_FIELD.ATHLETES.name);
    form.setFieldsValue({ [FORM_FIELD.ATHLETES.name]: [...previousAthletes, newAthlete] });
  };

  return (
    <ContentModuleModal
      visible={visible}
      title="Featured athletes"
      subtitle="Show up to 10 featured athletes in a carousel"
      okText={onDelete ? 'SAVE CHANGES' : 'ADD FEATURED ATHLETES'}
      onCancel={handleClose}
      onSubmit={form.submit}
      onDelete={onDelete}
      heroImageSrc={previewImg}
      errors={errors}
    >
      <AddSelectEntity addText="ADD ATHLETE" onAdd={handleAddAthlete} select={AthleteSelect} />
      <Form
        form={form}
        initialValues={initialValues}
        onSerializedFinish={handleSubmit}
        layout="vertical"
        name="featuredAthletes"
      >
        <SortableArrayField {...FORM_FIELD.ATHLETES} style={NO_MARGIN_BOTTOM} form={form} withPlaceholder withCount>
          {(athlete) => <InfoItem image={athlete.image}>{athlete.fullName}</InfoItem>}
        </SortableArrayField>
      </Form>
    </ContentModuleModal>
  );
};

FeaturedAthletesModal.Item = Item;

export default FeaturedAthletesModal;
